var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.65574V14.541C14.25 14.7005 14.2179 14.8583 14.1555 15.0051C14.0932 15.1519 14.0019 15.2846 13.8872 15.3954C13.7725 15.5061 13.6366 15.5926 13.4877 15.6497C13.3388 15.7068 13.1799 15.7333 13.0205 15.7277L12.9152 15.719L7.125 14.9954V8.65574H14.25ZM5.54167 8.65574V14.7975L1.387 14.2782C1.004 14.2303 0.651665 14.0442 0.396247 13.7548C0.140829 13.4654 -8.40215e-05 13.0927 3.75862e-08 12.7067V8.65574H5.54167ZM12.9152 0.00915962C13.0735 -0.0106082 13.2341 0.001696 13.3875 0.0453383C13.5408 0.0889806 13.6838 0.163067 13.808 0.263178C13.9321 0.363289 14.0348 0.487374 14.1099 0.628031C14.185 0.768688 14.2311 0.923036 14.2452 1.08187L14.25 1.18716V7.07241H7.125V0.732743L12.9152 0.00915962ZM5.54167 0.93066V7.07241H3.75862e-08V3.02145C-8.40215e-05 2.63547 0.140829 2.26275 0.396247 1.97336C0.651665 1.68397 1.004 1.49785 1.387 1.44999L5.54167 0.93066Z",
    fill: "#4D5874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/windows_icon.5eff1981616b0a0d1a906f9799d61901.svg";
export { ForwardRef as ReactComponent };